// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { VerticalCoachCardCoachFragmentDoc } from './VerticalCoachCard.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CoachesTabsHydratedCoachFragment = {
  __typename?: 'Coach';
  id: string;
  isSaved?: boolean | null;
};

export type CoachesTabsCoachFragment = {
  __typename?: 'Coach';
  id: string;
  slug: string;
  tier: Types.SkuTier;
  bio?: string | null;
  hourlyRate?: number | null;
  reviewTotal: number;
  averageReviewRate: number;
  isSaved?: boolean | null;
  couldScheduleIntro?: boolean | null;
  everHadCoachingSessionWithCoach?: boolean | null;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
  };
  categoryInformationList?: Array<{
    __typename?: 'CategoryInformation';
    headline?: string | null;
    id: string;
    category: {
      __typename?: 'Category';
      id: string;
      goal: Types.GoalName;
      sortRank?: number | null;
      slug: string;
      name: string;
    };
  }> | null;
  educationExperiences?: Array<{
    __typename?: 'Education';
    admissionCommittee: boolean;
    isFeatured?: boolean | null;
    school: {
      __typename?: 'School';
      id: string;
      name: string;
      logoLink?: string | null;
    };
  }> | null;
  professionalExperiences?: Array<{
    __typename?: 'ProfessionalExperience';
    experienceType?: Types.ExperienceType | null;
    isFeatured?: boolean | null;
    company: {
      __typename?: 'Company';
      id?: string | null;
      name: string;
      domain?: string | null;
      logoLink?: string | null;
    };
    endAt?: { __typename?: 'MonthYear'; year: number } | null;
  }> | null;
  availability?: {
    __typename?: 'CoachAvailability';
    nextAvailableAt?: number | null;
  } | null;
  coachingRelationship?: {
    __typename?: 'CoachingRelationship';
    id: string;
    paidTimeInMinute?: number | null;
    customerSubscription?: {
      __typename?: 'CustomerSubscription';
      id: string;
      sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
    } | null;
  } | null;
  outcomes?: Array<
    | {
        __typename?: 'CareerOutcomeSummary';
        companies: Array<{
          __typename?: 'Company';
          id?: string | null;
          name: string;
          logoLink?: string | null;
        }>;
      }
    | {
        __typename?: 'SchoolOutcomeSummary';
        schools: Array<{
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        }>;
      }
    | { __typename?: 'TestOutcomeSummary' }
  > | null;
  coachingTimeSummary?: {
    __typename?: 'CoachingTimeSummary';
    availableTime: number;
    hasUnlimitedPackage: boolean;
    cycles?: Array<{
      __typename?: 'SubscriptionCycle';
      timeInMinute: number;
      start?: number | null;
      end?: number | null;
    }> | null;
  } | null;
};

export type CoachesTabsGetCoachesQueryVariables = Types.Exact<{
  categoryUrn?: Types.InputMaybe<Types.Scalars['CategoryUrn']['input']>;
  subCategoryListFilter?: Types.InputMaybe<
    | Array<Types.Scalars['SubCategoryUrn']['input']>
    | Types.Scalars['SubCategoryUrn']['input']
  >;
}>;

export type CoachesTabsGetCoachesQuery = {
  __typename?: 'Query';
  popularCoaches: {
    __typename?: 'CoachSearchResponse';
    results: Array<{
      __typename?: 'Coach';
      id: string;
      slug: string;
      tier: Types.SkuTier;
      bio?: string | null;
      hourlyRate?: number | null;
      reviewTotal: number;
      averageReviewRate: number;
      isSaved?: boolean | null;
      couldScheduleIntro?: boolean | null;
      everHadCoachingSessionWithCoach?: boolean | null;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        pictureLink?: string | null;
      };
      categoryInformationList?: Array<{
        __typename?: 'CategoryInformation';
        headline?: string | null;
        id: string;
        category: {
          __typename?: 'Category';
          id: string;
          goal: Types.GoalName;
          sortRank?: number | null;
          slug: string;
          name: string;
        };
      }> | null;
      educationExperiences?: Array<{
        __typename?: 'Education';
        admissionCommittee: boolean;
        isFeatured?: boolean | null;
        school: {
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        };
      }> | null;
      professionalExperiences?: Array<{
        __typename?: 'ProfessionalExperience';
        experienceType?: Types.ExperienceType | null;
        isFeatured?: boolean | null;
        company: {
          __typename?: 'Company';
          id?: string | null;
          name: string;
          domain?: string | null;
          logoLink?: string | null;
        };
        endAt?: { __typename?: 'MonthYear'; year: number } | null;
      }> | null;
      availability?: {
        __typename?: 'CoachAvailability';
        nextAvailableAt?: number | null;
      } | null;
      coachingRelationship?: {
        __typename?: 'CoachingRelationship';
        id: string;
        paidTimeInMinute?: number | null;
        customerSubscription?: {
          __typename?: 'CustomerSubscription';
          id: string;
          sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
        } | null;
      } | null;
      outcomes?: Array<
        | {
            __typename?: 'CareerOutcomeSummary';
            companies: Array<{
              __typename?: 'Company';
              id?: string | null;
              name: string;
              logoLink?: string | null;
            }>;
          }
        | {
            __typename?: 'SchoolOutcomeSummary';
            schools: Array<{
              __typename?: 'School';
              id: string;
              name: string;
              logoLink?: string | null;
            }>;
          }
        | { __typename?: 'TestOutcomeSummary' }
      > | null;
      coachingTimeSummary?: {
        __typename?: 'CoachingTimeSummary';
        availableTime: number;
        hasUnlimitedPackage: boolean;
        cycles?: Array<{
          __typename?: 'SubscriptionCycle';
          timeInMinute: number;
          start?: number | null;
          end?: number | null;
        }> | null;
      } | null;
    }>;
  };
  professionalCoaches: {
    __typename?: 'CoachSearchResponse';
    results: Array<{
      __typename?: 'Coach';
      id: string;
      slug: string;
      tier: Types.SkuTier;
      bio?: string | null;
      hourlyRate?: number | null;
      reviewTotal: number;
      averageReviewRate: number;
      isSaved?: boolean | null;
      couldScheduleIntro?: boolean | null;
      everHadCoachingSessionWithCoach?: boolean | null;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        pictureLink?: string | null;
      };
      categoryInformationList?: Array<{
        __typename?: 'CategoryInformation';
        headline?: string | null;
        id: string;
        category: {
          __typename?: 'Category';
          id: string;
          goal: Types.GoalName;
          sortRank?: number | null;
          slug: string;
          name: string;
        };
      }> | null;
      educationExperiences?: Array<{
        __typename?: 'Education';
        admissionCommittee: boolean;
        isFeatured?: boolean | null;
        school: {
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        };
      }> | null;
      professionalExperiences?: Array<{
        __typename?: 'ProfessionalExperience';
        experienceType?: Types.ExperienceType | null;
        isFeatured?: boolean | null;
        company: {
          __typename?: 'Company';
          id?: string | null;
          name: string;
          domain?: string | null;
          logoLink?: string | null;
        };
        endAt?: { __typename?: 'MonthYear'; year: number } | null;
      }> | null;
      availability?: {
        __typename?: 'CoachAvailability';
        nextAvailableAt?: number | null;
      } | null;
      coachingRelationship?: {
        __typename?: 'CoachingRelationship';
        id: string;
        paidTimeInMinute?: number | null;
        customerSubscription?: {
          __typename?: 'CustomerSubscription';
          id: string;
          sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
        } | null;
      } | null;
      outcomes?: Array<
        | {
            __typename?: 'CareerOutcomeSummary';
            companies: Array<{
              __typename?: 'Company';
              id?: string | null;
              name: string;
              logoLink?: string | null;
            }>;
          }
        | {
            __typename?: 'SchoolOutcomeSummary';
            schools: Array<{
              __typename?: 'School';
              id: string;
              name: string;
              logoLink?: string | null;
            }>;
          }
        | { __typename?: 'TestOutcomeSummary' }
      > | null;
      coachingTimeSummary?: {
        __typename?: 'CoachingTimeSummary';
        availableTime: number;
        hasUnlimitedPackage: boolean;
        cycles?: Array<{
          __typename?: 'SubscriptionCycle';
          timeInMinute: number;
          start?: number | null;
          end?: number | null;
        }> | null;
      } | null;
    }>;
  };
  budgetFriendlyCoaches: {
    __typename?: 'CoachSearchResponse';
    results: Array<{
      __typename?: 'Coach';
      id: string;
      slug: string;
      tier: Types.SkuTier;
      bio?: string | null;
      hourlyRate?: number | null;
      reviewTotal: number;
      averageReviewRate: number;
      isSaved?: boolean | null;
      couldScheduleIntro?: boolean | null;
      everHadCoachingSessionWithCoach?: boolean | null;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        pictureLink?: string | null;
      };
      categoryInformationList?: Array<{
        __typename?: 'CategoryInformation';
        headline?: string | null;
        id: string;
        category: {
          __typename?: 'Category';
          id: string;
          goal: Types.GoalName;
          sortRank?: number | null;
          slug: string;
          name: string;
        };
      }> | null;
      educationExperiences?: Array<{
        __typename?: 'Education';
        admissionCommittee: boolean;
        isFeatured?: boolean | null;
        school: {
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        };
      }> | null;
      professionalExperiences?: Array<{
        __typename?: 'ProfessionalExperience';
        experienceType?: Types.ExperienceType | null;
        isFeatured?: boolean | null;
        company: {
          __typename?: 'Company';
          id?: string | null;
          name: string;
          domain?: string | null;
          logoLink?: string | null;
        };
        endAt?: { __typename?: 'MonthYear'; year: number } | null;
      }> | null;
      availability?: {
        __typename?: 'CoachAvailability';
        nextAvailableAt?: number | null;
      } | null;
      coachingRelationship?: {
        __typename?: 'CoachingRelationship';
        id: string;
        paidTimeInMinute?: number | null;
        customerSubscription?: {
          __typename?: 'CustomerSubscription';
          id: string;
          sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
        } | null;
      } | null;
      outcomes?: Array<
        | {
            __typename?: 'CareerOutcomeSummary';
            companies: Array<{
              __typename?: 'Company';
              id?: string | null;
              name: string;
              logoLink?: string | null;
            }>;
          }
        | {
            __typename?: 'SchoolOutcomeSummary';
            schools: Array<{
              __typename?: 'School';
              id: string;
              name: string;
              logoLink?: string | null;
            }>;
          }
        | { __typename?: 'TestOutcomeSummary' }
      > | null;
      coachingTimeSummary?: {
        __typename?: 'CoachingTimeSummary';
        availableTime: number;
        hasUnlimitedPackage: boolean;
        cycles?: Array<{
          __typename?: 'SubscriptionCycle';
          timeInMinute: number;
          start?: number | null;
          end?: number | null;
        }> | null;
      } | null;
    }>;
  };
};

export type CoachesTabsGetHydratedCoachesQueryVariables = Types.Exact<{
  coachSlugs:
    | Array<Types.Scalars['String']['input']>
    | Types.Scalars['String']['input'];
}>;

export type CoachesTabsGetHydratedCoachesQuery = {
  __typename?: 'Query';
  coachesBySlugs: Array<{
    __typename?: 'Coach';
    id: string;
    isSaved?: boolean | null;
  }>;
};

export const CoachesTabsHydratedCoachFragmentDoc = gql`
  fragment CoachesTabs_HydratedCoach on Coach {
    id
    isSaved
  }
`;
export const CoachesTabsCoachFragmentDoc = gql`
  fragment CoachesTabs_Coach on Coach {
    ...VerticalCoachCard_Coach
    ...CoachesTabs_HydratedCoach
  }
  ${VerticalCoachCardCoachFragmentDoc}
  ${CoachesTabsHydratedCoachFragmentDoc}
`;
export const CoachesTabsGetCoachesDocument = gql`
  query CoachesTabs_GetCoaches(
    $categoryUrn: CategoryUrn
    $subCategoryListFilter: [SubCategoryUrn!]
  ) {
    popularCoaches: searchCoaches(
      categoryUrn: $categoryUrn
      subCategoryListFilter: $subCategoryListFilter
      excludeLotteryCoaches: true
      count: 20
    ) {
      results {
        ...CoachesTabs_Coach
      }
    }
    professionalCoaches: searchCoaches(
      categoryUrn: $categoryUrn
      subCategoryListFilter: $subCategoryListFilter
      skuTiers: [ELITE, ELITE_PLUS]
      count: 20
    ) {
      results {
        ...CoachesTabs_Coach
      }
    }
    budgetFriendlyCoaches: searchCoaches(
      categoryUrn: $categoryUrn
      subCategoryListFilter: $subCategoryListFilter
      hourlyRateFilter: { end: 10000 }
      skuTiers: [BASE]
      count: 20
    ) {
      results {
        ...CoachesTabs_Coach
      }
    }
  }
  ${CoachesTabsCoachFragmentDoc}
`;

/**
 * __useCoachesTabsGetCoachesQuery__
 *
 * To run a query within a React component, call `useCoachesTabsGetCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachesTabsGetCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachesTabsGetCoachesQuery({
 *   variables: {
 *      categoryUrn: // value for 'categoryUrn'
 *      subCategoryListFilter: // value for 'subCategoryListFilter'
 *   },
 * });
 */
export function useCoachesTabsGetCoachesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CoachesTabsGetCoachesQuery,
    CoachesTabsGetCoachesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CoachesTabsGetCoachesQuery,
    CoachesTabsGetCoachesQueryVariables
  >(CoachesTabsGetCoachesDocument, options);
}
export function useCoachesTabsGetCoachesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoachesTabsGetCoachesQuery,
    CoachesTabsGetCoachesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CoachesTabsGetCoachesQuery,
    CoachesTabsGetCoachesQueryVariables
  >(CoachesTabsGetCoachesDocument, options);
}
export function useCoachesTabsGetCoachesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoachesTabsGetCoachesQuery,
        CoachesTabsGetCoachesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CoachesTabsGetCoachesQuery,
    CoachesTabsGetCoachesQueryVariables
  >(CoachesTabsGetCoachesDocument, options);
}
export type CoachesTabsGetCoachesQueryHookResult = ReturnType<
  typeof useCoachesTabsGetCoachesQuery
>;
export type CoachesTabsGetCoachesLazyQueryHookResult = ReturnType<
  typeof useCoachesTabsGetCoachesLazyQuery
>;
export type CoachesTabsGetCoachesSuspenseQueryHookResult = ReturnType<
  typeof useCoachesTabsGetCoachesSuspenseQuery
>;
export type CoachesTabsGetCoachesQueryResult = Apollo.QueryResult<
  CoachesTabsGetCoachesQuery,
  CoachesTabsGetCoachesQueryVariables
>;
export const CoachesTabsGetHydratedCoachesDocument = gql`
  query CoachesTabs_GetHydratedCoaches($coachSlugs: [String!]!) {
    coachesBySlugs(slugs: $coachSlugs) {
      ...CoachesTabs_HydratedCoach
    }
  }
  ${CoachesTabsHydratedCoachFragmentDoc}
`;

/**
 * __useCoachesTabsGetHydratedCoachesQuery__
 *
 * To run a query within a React component, call `useCoachesTabsGetHydratedCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachesTabsGetHydratedCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachesTabsGetHydratedCoachesQuery({
 *   variables: {
 *      coachSlugs: // value for 'coachSlugs'
 *   },
 * });
 */
export function useCoachesTabsGetHydratedCoachesQuery(
  baseOptions: Apollo.QueryHookOptions<
    CoachesTabsGetHydratedCoachesQuery,
    CoachesTabsGetHydratedCoachesQueryVariables
  > &
    (
      | {
          variables: CoachesTabsGetHydratedCoachesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CoachesTabsGetHydratedCoachesQuery,
    CoachesTabsGetHydratedCoachesQueryVariables
  >(CoachesTabsGetHydratedCoachesDocument, options);
}
export function useCoachesTabsGetHydratedCoachesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoachesTabsGetHydratedCoachesQuery,
    CoachesTabsGetHydratedCoachesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CoachesTabsGetHydratedCoachesQuery,
    CoachesTabsGetHydratedCoachesQueryVariables
  >(CoachesTabsGetHydratedCoachesDocument, options);
}
export function useCoachesTabsGetHydratedCoachesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoachesTabsGetHydratedCoachesQuery,
        CoachesTabsGetHydratedCoachesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CoachesTabsGetHydratedCoachesQuery,
    CoachesTabsGetHydratedCoachesQueryVariables
  >(CoachesTabsGetHydratedCoachesDocument, options);
}
export type CoachesTabsGetHydratedCoachesQueryHookResult = ReturnType<
  typeof useCoachesTabsGetHydratedCoachesQuery
>;
export type CoachesTabsGetHydratedCoachesLazyQueryHookResult = ReturnType<
  typeof useCoachesTabsGetHydratedCoachesLazyQuery
>;
export type CoachesTabsGetHydratedCoachesSuspenseQueryHookResult = ReturnType<
  typeof useCoachesTabsGetHydratedCoachesSuspenseQuery
>;
export type CoachesTabsGetHydratedCoachesQueryResult = Apollo.QueryResult<
  CoachesTabsGetHydratedCoachesQuery,
  CoachesTabsGetHydratedCoachesQueryVariables
>;
